<template>
  <vx-card>
    <div id="data-list-list-view">
      <vs-tabs>
        <vs-tab label="我的作品">
          <div class="con-tab-ejemplo">
            <!-- mineWorksSearchSheet -->
            <div class="margin-top">
              <vs-row vs-type="flex">
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>作品名：</span>
                    <vs-input class="inline-block margin" v-model="mineWorksSearchSheet.title"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>课程：</span>
                    <vs-input class="inline-block margin" v-model="mineWorksSearchSheet.course_name"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>章节：</span>
                    <vs-input class="inline-block margin" v-model="mineWorksSearchSheet.chapter_name"/>
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>类型：</span>
                    <v-select
                      class="inline-block margin width-100"
                      v-model="mineWorksSearchSheet.type"
                      label="name"
                      :options="typeList"
                      :clearable="false"
                    />
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>完成状态：</span>
                    <v-select
                      class="inline-block margin width-100"
                      v-model="mineWorksSearchSheet.is_finish"
                      label="name"
                      :options="workStatusList"
                      :clearable="false"
                    />
                </vs-col>
                <vs-col
                  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                    <span>批改状态：</span>
                    <v-select
                      class="inline-block margin width-100"
                      v-model="mineWorksSearchSheet.is_grade"
                      label="name"
                      :options="gradeStatusList"
                      :clearable="false"
                    />
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="flex-end">
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                  <vs-button class="margin" color="primary" type="filled" @click="searchMineWorks">搜索</vs-button>
                  <vs-button class="margin" color="warning" type="border" @click="resetMineWorksSheet">重置</vs-button>
                </vs-col>
              </vs-row>
            </div>
            <!-- mineWorksList -->
            <vs-table stripe ref="mineWorkTable" pagination :max-items="itemsPerPage" :data="workList">
              <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ workList.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : workList.length }} of {{ workList.length }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=5">
                      <span>5</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=10">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                      <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=20">
                      <span>20</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
              <template slot="thead" class="margin-top">
                <vs-th>序号</vs-th>
                <vs-th>作品名</vs-th>
                <vs-th>课程</vs-th>
                <vs-th>章节</vs-th>
                <vs-th>类型</vs-th>
                <vs-th>得分</vs-th>
                <vs-th>作品状态</vs-th>
                <vs-th>完成状态</vs-th>
                <vs-th><vx-tooltip text="若还未显示已批改，可能教师在课堂上已经检阅过了。" position="right">批改状态 <feather-icon class="ml-2" svgClasses="h-4 w-4"  icon="AlertCircleIcon"></feather-icon></vx-tooltip></vs-th>
                <vs-th>更新时间</vs-th>
                <vs-th>操作</vs-th>
              </template>
              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p class="product-name font-medium">{{ indextr + 1 }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.title?tr.title: '佚名' }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.course_name }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.chapter_name }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.task_type === 'homework'?'课后任务':'课堂练习' }}</p>
                    </vs-td>
                    <vs-td>
                      <p v-if="tr.is_grade" class="flex items-center"><feather-icon icon="StarIcon" class="color-orange margin-right" svgClasses="fill-current h-4 w-4" /><span>{{ tr.score }}</span></p>
                    </vs-td>
                    <vs-td>
                      <p v-if="tr.project_type == 0 || tr.project_type == 1">{{ tr.is_publish?'已发布':'未发布' }}</p>
                    </vs-td>
                    <vs-td>
                      <vs-chip color="success" v-if="tr.is_finish">已完成</vs-chip>
                      <vs-chip v-else>未完成</vs-chip>
                    </vs-td>
                    <vs-td v-if="tr.task_type == 'homework'">
                      <vs-chip color="warning" v-if="tr.is_grade">已批改</vs-chip>
                    </vs-td>
                    <vs-td v-else>
                      <vs-chip color="warning" v-if="tr.is_grade">已批改</vs-chip>
                      <vs-chip v-else-if="tr.is_finish">课堂中已检查</vs-chip>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.update_time }}</p>
                    </vs-td>
                    <vs-td>
                      <div>
                        <vs-button v-if="tr.is_grade" class="ml-4" color="success" size="small" type="filled" @click="openComment(tr)">查看评语</vs-button>
                        <vs-button v-if="tr.project_type == 0" class="ml-4" color="warning" size="small" type="filled" @click="openScratchWindow(tr.id)">查看作品</vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>

  </vx-card>
  
</template>

<script>
import { scratchWorkList } from '@/api/project'
import vSelect from 'vue-select';
import lodash from 'lodash'
import config from '@/config'

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      workList: [],
      currentPage: 1,
      itemsPerPage: 10,
      workStatusList: [
        {
          id: 1, 
          name: '已完成'
        },
        {
          id: 0,
          name: '未完成'
        }
      ],
      typeList: [
        {
          id: 0,
          name: '全部',
          val: 'all'
        },
        {
          id: 2,
          name: '课堂练习',
          val: 'classroom'
        },
        {
          id: 1,
          name: '课后任务',
          val: 'homework'
        }
      ],
      gradeStatusList: [
        {
          id: -1,
          name: '全部',
        },
        {
          id: 1, 
          name: '已批改'
        },
        {
          id: 0,
          name: '其他'
        }
      ],
      mineWorksSearchSheet: {
        title: '',
        course_name: '',
        chapter_name: '',
        is_finish: {
          id: 1, 
          name: '已完成'
        },
        type: {
          id: 0,
          name: '全部',
          val: 'all'
        },
        is_grade: {
          id: -1, 
          name: '全部'
        },
      },
    }
  },
  watch: {
    'mineWorksSearchSheet.is_finish'(newVal, oldVal) {
      console.log(newVal)
      if (newVal.id === 0) {
        this.mineWorksSearchSheet.is_grade = {id: 0, name: '其他'}
        this.gradeStatusList = [{id: 0, name: '其他'}]
      } else {
        this.mineWorksSearchSheet.is_grade = {id: -1, name:'全部'}
        this.gradeStatusList = [{id: -1, name:'全部'}, {id: 1, name: '已批改'},{id: 0, name: '其他'}]
      }
    }
  },
  mounted() {
    
    this.mineWorksInit();
  },
  methods: {
    mineWorksInit() {
      let params = lodash.clone(this.mineWorksSearchSheet);
      params.is_finish = params.is_finish.id
      params.is_grade = params.is_grade.id
      params.type = params.type.val
      scratchWorkList(params).then(res => {
        if (res.code == 1) {
          this.workList = res.data;
        }
      }).catch(() => {})
    },
    searchMineWorks() {
      this.mineWorksInit()
    },
    resetMineWorksSheet() {
      this.mineWorksSearchSheet = {
        title: '',
        course_name: '',
        chapter_name: '',
        is_finish: {
          id: 1, 
          name: '已完成'
        },
        is_grade: {
          id: -1, 
          name: '全部'
        },
        type: {
          id: 0,
          name: '全部',
          val: 'all'
        },
      }
      this.gradeStatusList = [{id: -1, name:'全部'}, {id: 1, name: '已批改'},{id: 0, name: '其他'}]
      this.mineWorksInit();
    },
    openScratchWindow(id) {
      window.open(`${config.scratchUrl}/?edit#${id}`, 'scratch');
    },
    openComment(row) {
      if (!row.comment) {
        this.$vs.notify({
          color: 'warning',
          text: '老师还没写评语',
          title: '提示',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `评语`,
          text: row.comment,
          acceptText: '谢谢老师'
        })
      }
      
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  white-space: nowrap;
}
.margin{
  margin: 0 0 0 1rem;
}
.margin-right{
  margin-right: 0.5rem;
}
.margin-top{
  margin-top: 20px;
}
.margin-bottom{
  margin-bottom: 20px;
}
.width-100{
  width: 100%;
}
.vs-col{
  margin-bottom: 20px;
}
.vs-con-input-label{
  width: 100%;
}
.vs-table--content{
  margin-top: 20px;
}
.vs-collapse{
  padding: 10px 0;
}
.flatpickr-input[readonly]{
  width: 100%;
}
.color-orange{
  color: orange;
}
</style>
